module.exports = __webpack_public_path__ + "static/img/background.739c95f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/OauthApply/background.png
// module id = XJwJ
// module chunks = 1